<template>
  <div class="imorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="list">
    <div style="height:15px"></div>
      <ul>
        <li v-for="(item,i) in scenic" @click="toPush(item.id,'imsuccess')">
          <div class="title">
            <img :src="baseUrl+item.img" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <div class="price">{{item.level}}级景区
              <font>营业时间：{{item.business}}</font>
              <font>状态：{{item.status == 1 ? '出票中' : '已出票'}}</font>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div style="height:60px"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        userData:[],
        scenic:[],
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/imorder');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') != null){
        this.getscenic();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      toPush:function(index,url){
        window.location.href="http://user.4008005216.com/main/"+url+'?id='+index
      },
      getscenic:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/tlist',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.scenic = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .imorderApp{
    display:block;
    background:#ececec;
    width:100%
  }
  .imorderApp .list ul{
    display:block;
    margin:0 auto;
    width:94%
  }
  .imorderApp .list ul li{
    display:block;
    width:100%;
    margin-bottom:15px;
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .imorderApp .list ul li .title{
    position:relative;
    width:100%;
  }
  .imorderApp .list ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .imorderApp .list ul li .title img{
    float:left;
    width:20%;
    border-radius:6px;
    margin-left:3%
  }
  .imorderApp .list ul li .title .conTitle{
    float:left;
    width:73%;
    margin-left:2%;
  }
  .imorderApp .list ul li .title .conTitle span{
    display:block;
    color:#000;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:15px;
    font-weight: 600;
  }
  .imorderApp .list ul li .title .conTitle font{
    color:#666;
    font-size:12px;
    padding-left:10px
  }

  .imorderApp .list ul li .title .conTitle .price{
    font-size: 12px;
    font-family: PingFang SC;
    color: #666;
    padding-top:15px
  }
  .imorderApp .list ul li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .imorderApp .list ul li .title .conTitle .price b{
    font-size:12px;
  }
  .imorderApp .list ul li .ticket{
    width:94%;
    margin:0 auto 1px auto;
    background:#f5f5f5;
    padding:10px 0;
    position:relative;
    border-radius:2px;
  }
  
</style>